import React from 'react'
import HackathonDetail from '../components/Hackathons/HackathonDetails'

function HackathonDetailsPage() {
  return (
    <div>
      <HackathonDetail/>
    </div>
  )
}

export default HackathonDetailsPage
